import UpdateProduct from "../../../components/@products/products/UpdateProduct";

import { routeTypes } from "../../../../../hooks/useSystemRoutes";

export default function ProductUpdatePage() {

    return (
        <UpdateProduct
            routeType={routeTypes.admin}
        />
    )
}       